
import BreadcrumbView from "../../common/breadcrumb/breadcrumb.html";
import RolesListView from "./roles-list.html";
import RolesEditView from "./roles-edit.html";

angular.module("roles", [])

    .config(['$stateProvider' ,function ($stateProvider) {
        $stateProvider
            .state('roles', {
                url: "/roles",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('roles.list', {
                url: "/list",
                controller: "RolesListCtrl",
                template: RolesListView,
                requiredPermission: ["ROLES_READ"]
            })
            .state('roles.edit', {
                url: "/edit/:id",
                controller: "RolesEditCtrl",
                template: RolesEditView,
                requiredPermission: ["ROLES_READ"]
            })
        ;
    }])
;